export const USERS_API_URL = process.env.REACT_APP_USERS_API_URL;
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const DOMAIN = process.env.REACT_APP_DOMAIN;
export const DEVICE_INFO_API_URL = process.env.REACT_APP_DEVICE_INFO_API_URL;
